import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      });

    case FETCH_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "Products fetched successfully",
      });

    case FETCH_PRODUCTS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        success: false,
        message: (action.payload && action.payload.error) || "Failed to fetch products",
      });

    case FETCH_PRODUCTS_RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default fetchProductsReducer;
